import React, { Component } from 'react';
import _ from 'lodash';
import './accountAlerts.css';
import { Accordion, Checkbox, MobileInputContainer } from '../../Shared';
import { isMobile } from '../../helpers/utils';
import './mobileStyles.css';
import InputWithIcon from '../../Shared/Input/InputWithIcon';

class AccountCategory extends Component {
    constructor(props) {
        super(props);
        let amount = 0;

        this.hasAlertRegistration = !!_.get(props.item, 'alertCriteria[0].type', null);
        if (this.hasAlertRegistration) {
            amount = _.get(props.alertRegistrations, '[0].alertCriteria[0].value', '');
        }

        this.state = {
            enabled: props.alertRegistrations.length > 0,
            amount: amount
        }
    }

    handleToggler = val => {
        const {
            alertRegistrations,
            removeAllAccountRegistrations,
            accountno
        } = this.props;
        if (val) {
            const registrationIds = alertRegistrations.map(item => item.id);
            removeAllAccountRegistrations(registrationIds, accountno);
        }

        this.setState({
            enabled: !this.state.enabled,
            amount: this.state.enabled ? "" : this.state.amount
        });
    }

    componentWillUpdate(newProps, newState) {
        if (newState.enabled !== this.state.enabled) {
            this.setState({
                enabled: newState.enabled
            })
        }
    }

    componentDidUpdate() {
        setTimeout(() => {
            var root = document.getElementById("root");

            var _event = {};

            _event = {
                name: 'END_SETTING_HEIGHT',
                height: root.parentElement.parentElement.offsetHeight
            };

            //Post END Height Event for OLB 
            window.parent.postMessage(_event, '*')
        },
            0)
    };

    handleChange = (e) => {
        let formattedAmount = 0;
        if (e.target.value === "" || e.target.value === "0" || e.target.value === "0.0") {
            formattedAmount = "";
        }
        else {
            formattedAmount = (Math.round(parseInt(e.target.value.replace('.', ''))) / 100).toFixed(2);
        }
        this.setState({
            amount: formattedAmount
        })
    }

    onBlur = () => {
        const registrationIds = this.props.alertRegistrations.map(item => item.id);
        this.props.updateAlertCriteria([{
            type: "Amount", value: this.state.amount || 0.00
        }], registrationIds);
    }

    renderContent = () => {
        const {
            item,
            alertRegistrations,
            categories,
            categoryContent,
            isEnabled,
            handleCheckBox
        } = this.props;

        return (
            <div className={isMobile() ? `child-part mobile-child-part` : "child-part"}>
                {!isMobile() && <h4>    <div className='subheader'>
                    {item.description}
                </div>
                </h4>}

                {
                    this.hasAlertRegistration ?
                        isMobile() ?
                            <div className="textbox-alignment">
                                <MobileInputContainer
                                    inputValue={this.state.amount}
                                    validationMessage={""}
                                    showValidation={!false}
                                    changeHandler={this.handleChange}
                                    needMask={false}
                                    onBlur={this.onBlur}
                                    inputWithSymbol={true}
                                    inputLabel={item.description + ':'}
                                />
                            </div>
                            :
                            <InputWithIcon value={this.state.amount} placeholder={"Enter Amount"} onChange={this.handleChange}
                                onBlur={this.onBlur} /> : ''

                }
                <div className="child-part-category-block">
                    {
                        categories.map((category, i) => {
                            const verifiedItems = categoryContent[i].filter(s => s.isVerified);
                            if (categoryContent[i] && categoryContent[i].length > 0 && verifiedItems.length > 0) {
                                return (
                                    <div className="child-part-category" key={i}>
                                        <h4>{category}</h4>
                                        {
                                            categoryContent[i].map((catCont, i) => (
                                                <div key={'catCont' + i}>

                                                    <Checkbox
                                                        headerText={item.name}
                                                        keyvalue={i}
                                                        verified={catCont.isVerified}
                                                        enabled={
                                                            isEnabled(alertRegistrations, catCont.id).length > 0
                                                        }
                                                        category={category}
                                                        label={catCont.displayValue || catCont.address}
                                                        callBack={() => {
                                                            let alertCriteria = []
                                                            if (this.hasAlertRegistration) {
                                                                alertCriteria = [{ type: "Amount", value: this.state.amount || 0 }];
                                                            }

                                                            const alertReg = alertRegistrations.find(s => s.deliveryMethod === catCont.id) || {}

                                                            handleCheckBox(
                                                                isEnabled(alertRegistrations, catCont.id).length > 0,
                                                                item,
                                                                catCont.id,
                                                                alertCriteria,
                                                                alertReg.id
                                                            )
                                                        }
                                                        }
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })
                    }
                </div>
            </div>
        );
    }

    render() {
        const { item } = this.props;

        if (isMobile()) {
            return (
                <Accordion
                    header={item.name}
                    enabled={this.state.enabled}
                    callback={val => this.handleToggler(val)}
                >
                    {this.renderContent()}
                </Accordion>
            );
        }

        return (
            <div className="accordion-main">
                <div className="alert-category-content-account-block">
                    <div className="account-block-name-details">
                        <h3>{item.name.toLowerCase()}</h3>
                    </div>
                </div>
                {this.renderContent()}
            </div>
        );
    }
}

export default AccountCategory;
